import { render, staticRenderFns } from "./xwzx.vue?vue&type=template&id=2a66a615&scoped=true"
import script from "./xwzx.vue?vue&type=script&lang=js"
export * from "./xwzx.vue?vue&type=script&lang=js"
import style0 from "./xwzx.vue?vue&type=style&index=0&id=2a66a615&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66a615",
  null
  
)

export default component.exports